import React, { forwardRef, useMemo } from "react";
import Select from "react-select";
import get from "lodash/get";
const ReactSingleSelect = forwardRef(({
    options = [],
    placeholder = "Select...",
    onChange,
    onBlur,
    value,
    disabled = false,
    errors = {},
    name,
    className = "",
    formatOptionLabel
}, ref) => {
    const errorMessage = get(errors, `${name}.message`);
    const formattedOptions = useMemo(() => {
        return options.map((item) => ({
            label: item.label || item.Label || item.name || item.Name || item.text || item.Text || "N/A",
            value: item.value !== undefined ? item.value : (item.Value !== undefined ? item.Value : item.id !== undefined ? item.id : item.Id),
            original: item // Keep reference to original item if needed
        }));
    }, [options]);
    return (
        <div className={`react-select-container ${className}`}>
            <Select
                ref={ref}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                options={formattedOptions}
                placeholder={placeholder}
                classNamePrefix="react-select"
                isDisabled={disabled}
                components={{ IndicatorSeparator: () => null }}
                menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                styles={{
                    menuPortal: base => ({ ...base, zIndex: 9999 })
                }}
                formatOptionLabel={formatOptionLabel}
                theme={(theme) => ({
                    ...theme,
                    borderRadius: 8,
                    colors: {
                        ...theme.colors,
                        primary: '#2f5aa2', /* focus color */
                        neutral20: '#adaeac', /* default border color */
                        neutral80: '#16191f', /* text color */
                    },
                })}
            />
            {errorMessage && (
                <span className="fs-9 fw-bold text-danger mt-1 d-block">{errorMessage}</span>
            )}
        </div>
    );
});
ReactSingleSelect.displayName = "ReactSingleSelect";
export default ReactSingleSelect;